<template>
	<bsf-viewbox>
		<bsf-navbar :logo="bslogo" fixed="top" slot="navbar">
		</bsf-navbar>
		<div slot="left" id="left">
			<sidebar></sidebar>
		</div>
		<div slot="right" id="right">
			<keep-alive>
				<router-view transition="back" v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view transition="back" v-if="!$route.meta.keepAlive"></router-view>
		</div>
		<routebox slot="tools"></routebox>
	</bsf-viewbox>
</template>

<script>
	import 'bootstrap/dist/css/bootstrap.min.css'
	import 'animate.css'
	import bslogo from "./assets/bs.png"
	//
	import bsfNavbar from "./components/comp/navbar"
	import sidebar from './components/sidebar'
	//
	import bsfLayout from './components/css/layout'
	import bsfCol from './components/css/col'
	//
	import warp from './components/warp'
	//
	import bsfViewbox from './components/doc/viewbox'
	//路由检测工具类 
	import routebox from './components/comp/routebox'

	export default {
		name: 'app',
		components: {
			bslogo,
			bsfViewbox,
			bsfNavbar,
			sidebar,
			bsfLayout,
			bsfCol,
			bsfViewbox,
			routebox,
		},
		data() {
			return {
				bslogo: bslogo,
			}
		},
		transitions: {
			back: {
				enterClass: 'back-enter',
				leaveClass: 'back-leave'
			}
		}
	}
</script>
<style lang="less">
	@import "./assets/lib/icon.less";
	@import (reference) "./assets/lib/css.less";
	body {
		font-family: @ffmix;
		background-color: @nbgc;
	}
	
	.container-fluid {
		.pd(0 2*@mpb)
	}
	
	#lgroup {
		.pd(0);
	}
	
	#rgroup {
		background-color: @cwh;
		.pd(2*@mpb);
		>div {
			.ohd;
		}
	}
	/**/
	
	.back-transition {
		.trs;
	}
	
	.back-enter {
		transform: translate(100%, 0);
	}
	
	.back-leave {
		transform: translate(-100%, 0);
	}
	/**/
	
	.doc {
		margin: 0 -15px;
		padding: 0 15px;
	}
	
	.doc-col {
		height: 50px;
		line-height: 50px;
		background-color: @cc2 ;
		.bdr;
		.mgb;
		.tac;
		color: @cwh;
	}
	
	.docmix {
		input+input {
			.mgt;
		}
		.input-group+.input-group {
			.mgt;
		}
		select+input {
			.mgt;
		}
		select+select {
			.mgt;
			&+input {
				.mgt;
			}
		}
		.dropdown+.dropdown:not(.btn-group),
		.dropup+.dropup,
		.dropup+.dropdown:not(.btn-group),
		.dropdown+.dropup {
			.mgt;
		}
		.dropdown,
		.dropup {
			&+input,
			&+.input-group {
				.mgt;
			}
		}
		.btn-group+.btn-group {
			.mgt(0);
		}
		.nav+.nav {
			.mgt
		}
		.label+.label {
			.mgl;
		}
	}
	
	.form-inline {
		.form-group+.form-group {
			.mgl;
		}
	}
</style>


// WEBPACK FOOTER //
// App.vue?24376d2d